import * as React from "react";
import PropTypes from "prop-types";
import Hamburger from "./Hamburger";
import Breadcrumb from "./Breadcrumb";
import User from "./User";

import "./Navigation.scss";

/**
 * Navigation component
 * @module
 * @param {object} [uzivatel] - User object
 * @param {element} [brand] - Brand element
 * @param {string} [path] - Path from menu
 * @param {func} onSignOut - Function invoked on sign out
 * @param {func} onClick - Function invoked on click
 * @param {func} [navUser] - Navigation user function
 * @param {func} [getManual] - Function to get manual
 * @param {func} [getListManual] - Function to get manual list
 * @param {manualProps} [manualProps] - Props for manual
 */

const Navigation = (props) => {
  return (
    <div className="navigation">
      <Hamburger onClick={props.onClick} icon={props.hamburgerIcon} />
      <Breadcrumb />
      {props.infoPanel ? props.infoPanel(props) : null}
      {props.navUser ? (
        props.navUser(props)
      ) : (
        <User
          uzivatel={props.uzivatel}
          onSignOut={props.onSignOut}
          userInfo={props.userInfo}
          handleOpenSettings={props.handleOpenSettings}
          manualProps={props.manualProps}
          getManual={props.getManual}
          getListManual={props.getListManual}
          getMessages={props.getMessages}
          getNotifications={props.getNotifications}
        />
      )}
    </div>
  );
};

Navigation.propTypes = {
  uzivatel: PropTypes.object,
  brand: PropTypes.element,
  path: PropTypes.array,
  onSignOut: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  infoPanel: PropTypes.func,
  navUser: PropTypes.func,
  getManual: PropTypes.func,
  getListManual: PropTypes.func,
  getMessages: PropTypes.func,
  getNotifications: PropTypes.func,
  hamburgerIcon: PropTypes.string,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    manualCustom: PropTypes.arrayOf(PropTypes.object),
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object,
  }),
};

export default Navigation;
